
import server from "@/public/service"
import { SUCCESS_CODE } from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import $router from "@/router";
import $store from "@/store"
import { Message} from "element-ui";

var storage = window.localStorage;
var sessionStorage = window.sessionStorage

var logout = ()=>{
    Message({
        type:"info",
        message:"登录信息失效，请重新登录",
        showClose:true
    })
    storage.removeItem("token");
    $store.state.userInfo = {};
    $router.push("/login");
}

export default ()=>{
    let token = sessionStorage.getItem("token") || storage.getItem("token");
    if(!token) return logout();
    return server.getUserInfo({ token }).then(data => {
        if (data.reCode === SUCCESS_CODE) {
          var result = getInterfaceData(data);
          $store.state.userInfo = result;
        } else {
            return logout();
        }
    })
}